import * as actionType from './action-type'
import initialState from './initial-state'

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionType.SET_LOGIN_ACCOUNT:
      return {
        ...state,
        user: payload.user
      }
    case actionType.SET_ACCOUNT_PERMISSIONS:
      return {
        ...state,
        permissions: payload.permissions
      }
    default:
      return state
  }
}
